import { useQuery } from "@tanstack/react-query";

import MagicLinkService, { MagicLinkArgs } from "@/api/services/magic-links";

export function useMagicLink(params: MagicLinkArgs) {
  return useQuery({
    queryKey: ["magic-link", params.orgID, params.linkID, params.isProd],
    queryFn: () => MagicLinkService.getMagicLink(params),
    enabled: !!params.orgID && !!params.linkID,
  });
}
